import * as React from "react";
import { JSX, useEffect } from "react";
import SelectableOption from "../model/SelectableOption";
import FilterOrAddInput from "../../label/FilterOrAddInput";

interface OptionSelectorProps {
  id?: string;
  options: SelectableOption[];
  title?: string;
  toggleView: (options: SelectableOption[]) => JSX.Element;
  onChange: (newOptions: SelectableOption[], changedOption: SelectableOption) => any;
  isValid?: (options: SelectableOption[]) => boolean;
  onCurrentFilterChange?: (value) => void;
  addLabelButton?: JSX.Element;
  optionClass?: string;
}

export default function OptionsSelector({
  id,
  options,
  title,
  toggleView,
  onChange,
  isValid,
  onCurrentFilterChange,
  addLabelButton,
  optionClass,
}: OptionSelectorProps) {
  const toggleOptionIfValid = (option, e) => {
    const selected = e.target["checked"];
    const newOptions = options.map((opt) => ({
      ...opt,
    }));
    const modifiedOption = newOptions.find((_option) => _option.label == option.label);
    modifiedOption.selected = selected;
    if (isValid == null || isValid(newOptions)) {
      onChange(newOptions, option);
    }
  };

  useEffect(() => {
    window["verticalDropdownUtil"] && window["verticalDropdownUtil"].reAttach();
  });

  return (
    <div
      id={id}
      onClick={(e) => e.stopPropagation()}
      className="options-selector vertical-dropdown action"
    >
      {title && <label>{title}</label>}
      <div className="vertical-dropdown-toggle">{toggleView(options)}</div>
      <div
        className={`
        options
        container-vertical-dropdown
        ${optionClass ? optionClass : ""}`}
      >
        {onCurrentFilterChange && (
          <FilterOrAddInput
            className="filter-or-add-input h-flex align-center"
            name="tag-filter-text"
            placeholder={i18n["Page.Patients.FilterOrAddTag"]}
            onCurrentFilterChange={onCurrentFilterChange}
          />
        )}
        {options.map((option) => (
          <label
            key={option.value}
            className={`option clickable h-flex align-center ${option.selected ? "selected" : ""}`}
          >
            <input
              type="checkbox"
              onChange={(e) => toggleOptionIfValid(option, e)}
              checked={option.selected}
            />
            <span>{option.label}</span>
          </label>
        ))}
        {addLabelButton && (
          <div className="add-label-button-container with-separator">{addLabelButton}</div>
        )}
      </div>
    </div>
  );
}
